import { render, staticRenderFns } from "./wenkong.vue?vue&type=template&id=ea3a708a&scoped=true&"
import script from "./wenkong.vue?vue&type=script&lang=js&"
export * from "./wenkong.vue?vue&type=script&lang=js&"
import style0 from "./wenkong.vue?vue&type=style&index=0&id=ea3a708a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3a708a",
  null
  
)

export default component.exports